import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

const OrganizationBrand: React.FC<{ name: string; logoUrl?: string | null }> = ({ name, logoUrl }) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (logoUrl && failedUrl !== logoUrl) {
    return <Box component="img" src={logoUrl} alt={name} onError={() => setFailedUrl(logoUrl)}
      sx={{ display: 'block', width: '100%', maxWidth: 192, height: 44, objectFit: 'contain', objectPosition: 'center', mx: 'auto' }} />;
  }
  return <Typography variant="h6" component="div" title={name} sx={{ fontWeight: 600, textAlign: 'center', width: '100%', overflowWrap: 'anywhere', lineHeight: 1.3 }}>{name}</Typography>;
};

export default OrganizationBrand;
